module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs notes-list"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n        累计" + _vm._s(_vm.tableData.length) + "次入库记录\n      ")]), _vm._v(" "), (this.moduleName === 'productionOrder') ? _c('div', {
    staticClass: "inline-item"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.handleListType
    },
    model: {
      value: (_vm.listType),
      callback: function($$v) {
        _vm.listType = $$v
      },
      expression: "listType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("成品")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("退料")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "item-list"
  }, [(!_vm.tableData.length) ? _c('li', {
    staticClass: "item center"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item) {
    return _c('li', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.addTime))]), _vm._v(" "), _c('div', {
      staticClass: "order"
    }, [_c('div', {
      staticClass: "id"
    }, [_c('i', {
      staticClass: "ico green"
    }, [_vm._v("单")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.openDetail(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.sheetNo))])]), _vm._v(" "), _c('div', {
      staticClass: "good"
    }, [_c('span', {
      staticClass: "thumb"
    }, [_c('img', {
      attrs: {
        "src": item.productImg
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.typeNum) + "种商品 共" + _vm._s(item.productNum) + "件")])]), _vm._v(" "), _c('div', {
      staticClass: "response"
    }, [_vm._v("负责人：" + _vm._s(item.userName))])])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21a0fae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/purchase/instock-log.vue
// module id = 1232
// module chunks = 82